import React, {useState, useRef, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import '@aws-amplify/ui-react/styles.css';
import '../App.css';
import AppLayout from "@awsui/components-react/app-layout";
import FormField from "@awsui/components-react/form-field";
import Alert from "@awsui/components-react/alert";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import SideNavigation from '@awsui/components-react/side-navigation';
import Button from "@awsui/components-react/button";
import TokenGroup from "@awsui/components-react/token-group";
import TopNavigation from "@awsui/components-react/top-navigation"
import SpaceBetween from "@awsui/components-react/space-between";
import ProgressBar from "@awsui/components-react/progress-bar";
import Amplify, {Auth, Storage} from 'aws-amplify';
import {Authenticator, Text, Image, View, useTheme} from '@aws-amplify/ui-react';
import HelpPanel from "@awsui/components-react/help-panel";
import Icon from "@awsui/components-react/icon";
import awsconfig from '../aws-exports';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Navigate } from "react-router-dom";
import {Login, OTPPAGE, ResetPassword, ForgotPassword} from "./Login";

// import "bootstrap/dist/css/bootstrap.min.css"
Amplify.configure(awsconfig);

Auth.configure({authenticationFlowType: 'CUSTOM_AUTH'});
var loggedIn = false;
var userName = "";
var userOTP;
var time;
var currTime = Date.now();
var checkTimer = false;
var inactivityTime = function () { 
    resetTimer()
    window.onload = resetTimer;
    // DOM Events
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;
    function logout() {
        if (loggedIn){
            Auth.currentAuthenticatedUser({
                bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            })
                .then((user) => {
                    Auth.signOut().then(() => {
                        alert("You are now logged out.")
                        loggedIn = false;
                        userName = "";
                        window.location.reload();
                    });})
                .catch((err) => {
                    console.log(err)
                    window.location.reload();
                });
        }
        else {
            console.log("logout not logged in!");
            window.location.reload();
        }
    }
    function resetTimer() {
        if (checkTimer)
        {
            if (loggedIn) {
                clearTimeout(time);
                console.log("Timer Reset!")
                time = setTimeout(logout, 900000)
            }
            else {
                console.log("reset not logged in!");
                Auth.currentAuthenticatedUser({
                    bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
                })
                    .then((user) => {
                        console.log(user);
                        var authTime = user["signInUserSession"]["accessToken"]["payload"]["auth_time"];
                        var timeDiff = currTime - (authTime * 1000)
                        console.log(timeDiff)
                        if (timeDiff > 50000) {
                            window.location.reload();
                        }
                        
                    })
                    .catch((err) => {
                        console.log(err);
                        checkTimer = false;
                        console.log("test")
                        window.location.reload();
                    });
            } 
        }
       
        // 1000 milliseconds = 1 second 1200000 = 20 minutes 300000 = 5 minutes
    }
};
function formatBytes(a, b = 2, k = 1024) {
    let d = Math.floor(Math.log(a) / Math.log(k));
    return 0 === a ? "0 Bytes" : parseFloat((a / Math.pow(k, d)).toFixed(Math.max(0, b))) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
}

const appLayoutLabels = {
    navigation: 'Side navigation',
    navigationToggle: 'Open side navigation',
    navigationClose: 'Close side navigation',
    notifications: 'Notifications',
    tools: 'Help panel',
    toolsToggle: 'Open help panel',
    toolsClose: 'Close help panel'
};
 
 const ServiceNavigation = () => {
    const location = useLocation();
    let navigate = useNavigate();

    function onFollowHandler(event) {
        if (!event.detail.external) {
            event.preventDefault();
            navigate(event.detail.href);
        }
    }
//side navigation information
    return (
       <SideNavigation
             activeHref={location.pathname}
            header={{href: "/", text: "EAS-E Uploader Tool"}}
            onFollow={onFollowHandler}
            items={[
                {
                    type: "link", 
                    text: "Logout", 
                    href: "/login"
                },
                {
                    type: "divider"
                },
                /*{
                    type: "link",
                    text: "Test",
                    href: "Michael.J.Walker@hotmail.com",
                    external: false
                }*/
            ]} 
        />
        );
} 
//notice board
const HelpNavigation = () => {
    return (
        <HelpPanel
            footer={
                <div>
                    <h1>EAS-E Uploader Tool</h1>
                    <i>Delivering your data needs, whenever and wherever you are</i>
                </div>
            }
            header={<h2>Notice Board</h2>}
        >
            <div>
                <p>
                    Please check back here from time to time for upcoming outages, <i>new features</i>, updates, and other useful information.
                </p>
               
               <p>
                      <dt>ZIP Files</dt>
                    <dd>Currently, .rvt files will need to be compressed and zipped for it to be deliver up.</dd>
                    
                     <dt>PDF Files</dt>
                    <dd>Currently, .pdf files will need to be flattened for it to be deliver up.</dd>
                </p>
                
                <p>
                 <dt>How to Flatten PDF Files</dt>
                    <dd>To flatten a pdf, all you have to do is open up the pdf in your preferred PDF application, click print, and select "Print to PDF" as your printer. The newly saved pdf will be flattened and you can upload it.</dd>
                </p>
                
                <h3>Helpful Informations</h3>
                <dl>
                    <dt>Notification Process</dt>
                    <dd>During the onboarding session, we associate the provided email with our notification stack. Essentially, whenever you upload an object, our backend infrastructure will send a confirmation reciept. You should see an email from <b>no-reply@goldcherrygumdrop.com</b>. If you see something else, run!</dd>
                    <dt>EAS-E UI Information</dt>
                    <dd>This UI will automatically log you out after 15 minutes of inactivity. However, the timer resets when it picks up activity. The UI will retain the name of the objects that was successfully delivered. Refreshing the window will refresh remove it and their are no way of retrieving what was delivered.</dd>
                    <dt>Auto Disable Information</dt>
                    <dd>Accounts will be disabled after 30 days of inactivity. Please reach out to your POC for account re-activation.</dd>
                </dl>
            </div>
        </HelpPanel>
    );
}
   
const Content = () => {
   
    const hiddenFileInput = useRef(null);
    const location = useLocation();
    const [visibleAlert, setVisibleAlert] = useState(false);
    
    const [uploadList, setUploadList] = useState([]);
    
    const [fileList, setFileList] = useState([]);
    
    const [historyList, setHistoryList] = useState([]);
    
    const [historyCount, setHistoryCount] = useState(0);
      const { state } = useLocation();
   
    const handleClick = () => {
        hiddenFileInput.current.value = ""; // This avoids errors when selecting the same files multiple times
        hiddenFileInput.current.click();
    };
    
    const handleChange = e => {
        e.preventDefault();
        let i, tempUploadList = [];
        for (i = 0; i < e.target.files.length; i++) {
            if (e.target.files[i].name.length > 9000) {
                setVisibleAlert(true);
            }
            else {
                tempUploadList.push({
                    label: e.target.files[i].name,
                    labelTag: formatBytes(e.target.files[i].size),
                    description: 'File type: ' + e.target.files[i].type,
                    icon: 'file',
                    alt: 'file',
                    id: i
                })
            }
        }
        setUploadList(tempUploadList);
        setFileList(e.target.files);
    };

    // drag state

    const [dragActive, setDragActive] = useState(false);
    // ref
    const inputRef = useRef(null);

    
    // handle drag events
    const handleDrag = function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragActive(true);
      } else if (e.type === "dragleave") {
        setDragActive(false);
      }
    };
    
    // triggers when file is dropped
    const handleDrop = function(e) {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        // handleFiles(e.dataTransfer.files);
        let i, tempUploadList = [];
        for (i = 0; i < e.dataTransfer.files.length; i++) {
            if (e.dataTransfer.files[i].name.length > 9000) {
                setVisibleAlert(true);
            }
            else {
                tempUploadList.push({
                    label: e.dataTransfer.files[i].name,
                    labelTag: formatBytes(e.dataTransfer.files[i].size),
                    description: 'File type: ' + e.dataTransfer.files[i].type,
                    icon: 'file',
                    alt: 'file displayed',
                    id: i
                })
            }
        }
        setUploadList(tempUploadList);
        setFileList(e.dataTransfer.files);
      }
    };
    function progressBarFactory(fileObject) {
        let localHistory = historyList;
        
        const id = localHistory.length;
        localHistory.push({
            id: id,
            percentage: 0,
            filename: fileObject.name,
            filetype: fileObject.type,
            filesize: formatBytes(fileObject.size),
            status: 'in-progress'
        });
        setHistoryList(localHistory);
        return (progress) => {
            let tempHistory = historyList.slice();
            const percentage = Math.round((progress.loaded / progress.total) * 100);
            tempHistory[id].percentage = percentage;
            if (percentage === 100) {
                tempHistory[id]['status'] = 'success';
            }
            setHistoryList(tempHistory);
        };
    }

    const handleUpload = () => {
     
        if (uploadList.length === 0) {
            setVisibleAlert(true);
        } else {
            
            console.log('Uploading files to EAS-E');
            if (userName === "") {
                Auth.signOut().then(() => {
                    // alert("You are now logged out.")
                    alert("ERROR: Upload Failed. Please re-login.")
                    loggedIn = false;
                    userName = ""; 
                    window.location.reload();
                });
            } else {
                let i, progressBar = [], uploadCompleted = [];
                for (i = 0; i < uploadList.length; i++) {
                    // If the user has removed some items from the Upload list, we need to correctly reference the file
                    const id = uploadList[i].id;
                   
                    progressBar.push(progressBarFactory(fileList[id]));
                    setHistoryCount(historyCount + 1);
                    // Auth.currentUserInfo().then((user) => )
                    var fileName = fileList[id].name
                    // fileName = fileName.replace(' ','_')
                    fileName = fileName.replace('__','_')
    
                    uploadCompleted.push(Storage.put(userName+"__"+fileName, fileList[id], {
                            progressCallback: progressBar[i],
                            level: "private"
                        }).then(result => {
                            // Trying to remove items from the upload list as they complete. Maybe not work correctly
                            // setUploadList(uploadList.filter(item => item.label !== result.key));
                            console.log(`Completed the upload of ${result.key}`);
                        })
                    );
                }
                inactivityTime()
                // When you finish the loop, all items should be removed from the upload list
                Promise.all(uploadCompleted)
                    .then(() => setUploadList([]));
            }
        }
    }

    const handleDismiss = (itemIndex) => {
        setUploadList([
            ...uploadList.slice(0, itemIndex),
            ...uploadList.slice(itemIndex + 1)
        ]);
    };

    const List = ({list}) => (
        <>
            {list.map((item) => (
                <ProgressBar
                    key={item.id}
                    status={item.status}
                    value={item.percentage}
                    variant="standalone"
                    additionalInfo={item.filesize}
                    description={item.filetype}
                    label={item.filename}
                />
            ))}
        </>
    );
        
    const handleLogout = () => {
       
        loggedIn = false;
        userName = "";
        Auth.signOut();
        window.location.reload();
    }

    inactivityTime();
    
//main page
    return (
            <SpaceBetween size="l">
                <Container
                    id="s3-upload-multiple-objects"
                    header={
                        <Header variant="h1" title="Upload multiple objects to EAS-E">
                            Upload multiple objects to EAS-E
                        </Header>
                    }
                >
                    {
                        <div aria-live="polite">
                            <Alert
                                onDismiss={() => setVisibleAlert(false)}
                                visible={visibleAlert}
                                dismissAriaLabel="Close alert"
                                dismissible
                                type="error"
                                header="No files selected"
                            >
                                You must select the files that you want to upload. File Names must be less than 90 characters in length.
                            </Alert>
                            <FormField
                                label='Object Upload'
                                description='Drag and Drop the files that you want to upload'
                            />
                            <form id="form-file-upload" onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                                <input ref={inputRef} type="file" id="input-file-upload" name="input-file-upload" multiple={true} onChange={handleChange} />
                                <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : "" }>
                                  <div aria-live="polite">
                                    <p>Drag and drop your file here or </p>
                                    <Button onClick={handleClick}
                                        iconAlign="left"
                                        iconName="upload"
                                        alt="upload"
                                        tabIndex = "1"
                                    >
                                        Choose file[s]
                                    </Button>
                                  </div>
                                </label>
                                { dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
                            </form>
                            <SpaceBetween direction="horizontal" size="xs">
                                
                                <input
                                    type="file"
                                    ref={hiddenFileInput}
                                    onChange={handleChange}
                                    style={{display: 'none'}}
                                    multiple
                                />
                                <button className='btn btn-primary' type="upload" title="Upload" onClick={handleUpload} tabIndex = "2">Upload</button>
                            </SpaceBetween>
    
                            <TokenGroup
                                onDismiss={({detail: {itemIndex}}) => {
                                    handleDismiss(itemIndex)
                                }}
                                items={uploadList}
                                alignment="vertical"
                                limit={10}
                            />
                        </div>
                    }
                </Container>
                <Container 
                    id="charWarn" 
                    header={
                        <Header variant="h2" title="Character Limitation">
                            Character Limitation
                        </Header>
                    }
                >
                <p title="Character limit of 90 ">Please be aware of the number of characters when naming your files. Currently, the EASE Uploader Tool will <b><u>ONLY</u></b> accept up to 90 characters. If the number of characters are exceeded then the EASE Uploader Tool will <b>FAIL</b> and will not be transferred.</p>
                </Container>
                <Container
                    id="history"
                    header={
                        <Header variant="h3" title="History">
                            History
                        </Header>
                    }
                >
                    <List list={historyList}/>
                </Container>
                <Container      
                    header={<Header variant="h4" description="Changes made to EAS-E Front-End will be displayed here">Release Changes (RC)</Header>} 
                >      
                    <ul>
                        <li>04/16/2024 - EASE_FE v1.03 - Added auto disable of inactive users</li>
                        <li>05/03/2023 - EASE_FE v0.02 - deployed for testing/accessibility</li>
                        <li>04/28/2023 - EASE_FE v0.01 - deployed for demo</li>
                    </ul>
                </Container>
                <Container
                    id="logout"
                    header={
                        <Header variant="h5" title="Log Out">
                            Log Out
                        </Header>
                    }
                >
                    <button className='btn btn-primary' type="logout" title="Log out" tabIndex = "2" onClick={handleLogout}
                                >
                                    Log Out
                                </button>
                </Container>
            </SpaceBetween>
        );
};

const AppLayoutUI = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(true);
    let{state} =useLocation(); 
    if (state ==null) {
        return <Navigate replace to="/login" />;
    } 
    console.log(currTime)
    currTime = Date.now();
    console.log(currTime)
    inactivityTime();
    let {authLoggedIn, authUserName, user} =state;
    loggedIn = authLoggedIn;
    userName = authUserName;

    Auth.currentAuthenticatedUser({
                bypassCache: false // Optional, By default is false. If set to true, this call will send a request toUni Cognito to get the latest user data
            })
                .then((user) => {
                    console.log(user);
                    var authTime = user["signInUserSession"]["accessToken"]["payload"]["auth_time"];
                    // var exp = user["signInUserSession"]["accessToken"]["payload"]["exp"];
                    // // console.log(user["signInUserSession"]["accessToken"]["payload"]["auth_time"]);
                    // // console.log(user["signInUserSession"]["accessToken"]["payload"]["exp"]);
                    // // console.log(currTime)
                    var timeDiff = currTime - (authTime * 1000)
                    console.log(timeDiff)
                    if (timeDiff > 50000) {
                        loggedIn = false;
                        window.location.reload();
                    }
                    
                })
                .catch((err) => {
                    console.log(err);
                    // checkTimer = false;
                    loggedIn = false;
                    // window.location.reload();
                });
    
    const navbarItemClick = e => {
        console.log(e);
        if (e.detail.id === 'signout') {
            Auth.signOut().then(() => {
                window.location.reload();
                loggedIn = false;
                userName = "";
            });
        }
    }

    useEffect(() => {  
        const onBeforeUnload = (ev) =>{
            // ev.preventDefault();
            // ev.stopPropagation();
            //ev.returnValue = false; 
            console.log("here");
            loggedIn = false;
            checkTimer = false;
            Auth.signOut().then(() => {
                        alert("You are now logged out.")
                        loggedIn = false;
                        userName = "";
                    });
            window.history.replaceState({}, document.title)
        };    
        window.addEventListener("beforeunload",onBeforeUnload)
        return () => {
            window.removeEventListener("beforeunload",onBeforeUnload)
    onBeforeUnload();
        };
    }, []);
   
       

    //navbar information
    if(loggedIn){
        window.onload = function() {
        inactivityTime();
        }
        checkTimer = true;
         return(
        <>
          <div aria-live="polite" id="navbar" style={{fontSize: 'body-l !important', position: 'sticky', top: 0, zIndex: 1002}}>
                <TopNavigation
                    identity={{
                        href: "#",
                        title: "EAS-E Uploader Tool",
                        logo: {
                            src:
                                "data:image/svg+xml;base64,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",
                            alt: "EAS-E Upload Tool"
                        }
                    }}
                    utilities={[
                        {
                            type: "menu-dropdown",
                            tabIndex: "0",
                            text: userName,
                            description: userName,
                            iconName: "user-profile",
                            alt: "user profile",
                            onItemClick: navbarItemClick,
                            items: [
                                {id: "signout", text: "Sign out"}
                            ]
                        }
                    ]}
                    i18nStrings={{
                        searchIconAriaLabel: "Search",
                        searchDismissIconAriaLabel: "Close search",
                        overflowMenuTriggerText: "More",
                        lng: 'en'
                    }}
                    className="pad-top"
                />
            </div>
            <AppLayout
                content={<Content/>}
                headerSelector='#navbar'
                navigation={<ServiceNavigation/>}
                navigationOpen={navigationOpen}
                onNavigationChange={({detail}) => setNavigationOpen(detail.open)}
                ariaLabels={appLayoutLabels}
                tools={<HelpNavigation/>}
                toolsOpen={toolsOpen}
                onToolsChange={({detail}) => setToolsOpen(detail.open)}
            />
        </>
        );
    } 
    else {
        return <Navigate replace to="/login" />;
    }
};

// const components = {
//     Header() {
//         const { tokens } = useTheme();
        
//         return (
//             <View textAlign="center" padding={tokens.space.large}>
//                 <Image 
//                     alt="Amplify logo"
//                     src="https://docs.amplify.aws/assets/logo-dark.svg"
//                 />
//             </View>
//         );
//     },
//     Footer() {
//         const { tokens } = useTheme();
        
//         return (
//             <View textAlign="center" padding={tokens.space.large}> 
//                 <Text color={tokens.colors.white}>
//                     &copy; All Rights Reserved
//                 </Text>
//             </View>
//         );
//     },
// };
//login page
// const Login = () => {
//     const navigate = useNavigate();
//     const [username, setUserName] = useState("");
//     const [password, setPassword] = useState("");
    
//     const [authenticated, setauthenticated] = useState(window.localStorage.getItem(window.localStorage.getItem("authenticated")|| false));
//     function handleSubmit() {
//             try {
//                 event.preventDefault();
//                 Auth.signIn(username, password)
//                     .then(user => {
//                         userOTP = user;
//                         if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
//                             navigate("/resetpassword")
//                         }
//                         else
//                         {
//                             userName = username;
//                             console.log(user);
//                             navigate("/otppage");
//                         }
    
//                     })
//                     .catch(() => {
//                         alert("Incorrect UserName or Password!")
//                         window.location.reload();
//                     });
//                 // console.log(user);
//                 // const check = Auth.sendCustomChallengeAnswer(user, 'blue');
                
//                 // console.log(check);
//                 console.log(Auth.currentAuthenticatedUser())
//             } catch (error) {
//                 console.log('error signing in', error);
//             }
        
//     }
//     //forgot password page
//     function forgotPassword(){
//         try{
//             var usernameForgot = prompt('Please enter your username.')
//             event.preventDefault();
//             userName = usernameForgot;
//             Auth.forgotPassword(userName)
//                 .then(user => {
//                     userOTP = user;
//                     navigate("/forgotpassword")
//                 })
//                 .catch(() => {
//                     alert("Incorrect UserName or Password!")
//                     window.location.reload();
//                 });
//             // console.log(user);
//             // const check = Auth.sendCustomChallengeAnswer(user, 'blue');
            
//             // console.log(check);
//             console.log(Auth.currentAuthenticatedUser())
//         } catch (error) {
//             console.log('error resetting password in', error);
//         }
//     }
//     return (
//         <div className="Auth-form-container">
//             <form className="Auth-form" onSubmit={handleSubmit}>
//                 <div className="Auth-form-content">
//                     <h3 className="Auth-form-title">SIGN INTO EAS-E</h3>
//                     <div className="form-group mt-3">
//                         <label>User Name</label>
//                             <input
//                                 type="text"
//                                 className="form-control mt-1"
//                                 placeholder="Enter your user name"
//                                 onChange={e => setUserName(e.target.value)}
//                             />
//                     </div>
//                     <div className="form-group mt-3">
//                         <label>Password</label>
//                             <input
//                                 type="password"
//                                 className="form-control mt-1"
//                                 placeholder="Enter your password"
//                                 onChange={e => setPassword(e.target.value)}
//                             />
//                     </div>
//                     <div className="d-grid gap-2 mt-3">
//                         <button type="submit" className="btn btn-primary" onClick={() => handleSubmit}>
//                         Submit
//                         </button>
//                         <div className="d-grid gap-2 mt-3">
//                         <button type ="text" className="btn btn-secondary" onClick={forgotPassword}>
//                         Forgot Password
//                         </button>
//                         </div>
//                     </div>
//                 </div>
//             </form>
//         </div>
//     );
// };
// //otppage
// const OTPPAGE = () => {
//     const navigate = useNavigate();
//     const [answer, setAnswer] = useState("");
//     const [authenticated, setauthenticated] = useState(window.localStorage.getItem(window.localStorage.getItem("authenticated")|| false));
//     var attempts = 0;
//     function handleSubmit() {
//         try {
//             event.preventDefault();
//             console.log(userOTP)
//             Auth.sendCustomChallengeAnswer(userOTP, answer)
//                 .then(user => {
//                     console.log(user);
//                     Auth.currentAuthenticatedUser()
//                         .then(user => {
//                             setauthenticated(true);
//                             loggedIn = true;
//                             window.localStorage.setItem("authenticated", true);
//                             window.onload = function() {
//                                 console.log("start")
//                                 inactivityTime();
//                             }
//                             navigate("/content");
//                         })
//                 })
//                 .catch(() => {
//                     attempts++;
//                     console.log(attempts);
//                     if (attempts >=3) {
//                         alert("Max Attempts Reached! Please Log Back In.")
//                         userOTP = null;
//                         userName = "";
//                         navigate("/login")
//                     }
//                     else{
//                         alert("Incorrect OTP! Please try again.")
//                     }
//                 });
            
            
                    
//             // console.log(user);
//             // const check = Auth.sendCustomChallengeAnswer(user, 'blue');
            
//             // console.log(check);
//             console.log(Auth.currentAuthenticatedUser())
//         } catch (error) {
//             console.log('error signing in', error);
//             navigate("/login");
//         }
//     }
//     if (userOTP != null){
//         return (
//             <div className="Auth-form-container">
//                 <form className="Auth-form" onSubmit={handleSubmit}>
//                     <div className="Auth-form-content">
//                         <h3 className="Auth-form-title">Enter OTP</h3>
//                         <div className="form-group mt-3">
//                             <label>Check your email for the code from</label>
//                           <div className="form-group mt-2">
//                             <label>no-reply@goldcherrygumdrop.com</label>
//                                 </div>
//                                 <input
//                                     type="text"
//                                     className="form-control mt-1"
//                                     placeholder="Enter the OTP code recieved from email."
//                                     onChange={e => setAnswer(e.target.value)}
//                                 />
//                                 </div>
//                             <div className="form-group mt-3"> 
//                             <label> You should be recieving an email within 5 minutes. </label>
//                             </div>
//                         <div className="d-grid gap-2 mt-3">
                       
                        
//                             <button type="submit" className="btn btn-primary" onClick={() => handleSubmit}>
//                             Submit
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         );
//     }
//     else {
//         return <Navigate replace to="/login" />;
//     }
    
// };
// //reset password page
// const ResetPassword = () => {
//     const navigate = useNavigate();
//     const [newPassword, setPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");
//     function handleSubmit() {
//         try {
//             event.preventDefault();
//             console.log(userOTP)
//             var re = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")
//             if (newPassword ==confirmPassword){
//                 if (re.test(newPassword) && newPassword.length > 11){
//                     Auth.completeNewPassword(
//                         userOTP,               // the Cognito User Object
//                         newPassword,        // the new password
//                     ).then(user => {
//                         alert("Please log in with your new password.")
//                         userOTP = null;
//                         userName = "";
//                         navigate("/login")
//                     }).catch(e => {
//                         alert("Password change failed, please try a different password.")
//                     })

//                 }
//                 else{
//                     alert("Password must be at least 12 characters in length, contain an UPPERCASE, lowercase, Number, and special character.")
//                 }
//             }
//             else{
//                 alert("Passwords do not match.")
//             }
//         } catch (error) {
//             console.log('error signing in', error);
//             navigate("/login");
//         }
//     }
//     if (userOTP != null)
//     {
//         return (
//             <div className="Auth-form-container">
//                 <form className="Auth-form" onSubmit={handleSubmit}>
//                     <div className="Auth-form-content">
//                         <h3 className="Auth-form-title">Enter New Password</h3>
//                         <div className="form-group mt-3">
//                             <label>Please Enter a New Password</label>
//                                 <input
//                                     type="password"
//                                     className="form-control mt-1"
//                                     placeholder="Please Enter a new Password"
//                                     onChange={e => setPassword(e.target.value)}
//                                 /></div>
//                                 <div className="form-group mt-3">
//                                 <input
//                                     type="password"
//                                     className="form-control mt-1"
//                                     placeholder="Please confirm your new Password"
//                                     onChange={e => setConfirmPassword(e.target.value)}
//                                 />
//                                 </div>
//                                 <div className="form-group mt-3">
//                                  <label> *Password must be at least 12 characters in length, and must contain an UPPERCASE, lowercase, Number, and a Special Character.</label>
//                                  </div>
                        
//                                     <div className="d-grid gap-2 mt-3">
//                                     <button type="submit" className="btn btn-primary" onClick={() => handleSubmit}>
//                                      Submit
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         );
//     }    else {
//         return <Navigate replace to="/login" />;
//     }
// };
// //forgot password page
// const ForgotPassword = () => {
//     const navigate = useNavigate();
//     const [newPassword, setPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");
//     const [code, setCode] = useState("");
//     function handleSubmit() {
//         try {
//             event.preventDefault();
//             console.log(userName)
//             if (newPassword ==confirmPassword){
//                 var re = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")
//                 if (re.test(newPassword) && newPassword.length > 11){
//                     Auth.forgotPasswordSubmit(
//                         userName,               // the Cognito User Object
//                         code,
//                         newPassword,        // the new password
//                     ).then(user => {
//                         alert("Please log in with your new password.")
//                         userOTP = null;
//                         userName = "";
//                         navigate("/login")
//                     }).catch(e => {
//                         alert("Password change failed, please try a different password.")
//                     })

//                 }else{
//                     alert("Password must be at least 12 characters in length, contain an UPPERCASE, lowercase, Number, and special character.")
//                 }
//             }
//             else{
//                 alert("Passwords do not match.")
//             }
//         } catch (error) {
//             console.log('error signing in', error);
//             navigate("/login");
//         }
//     }
//     if (userName != "")
//     {
//         return (
//             <div className="Auth-form-container">
//                 <form className="Auth-form" onSubmit={handleSubmit}>
//                     <div className="Auth-form-content">
//                         <h3 className="Auth-form-title">Forgot Password</h3>
//                         <div className="form-group mt-3">
//                             <label>Please Enter the Code Emailed to You:</label>
//                                 <input
//                                     type="text"
//                                     className="form-control mt-1"
//                                     placeholder="Enter the code emailed to you."
//                                     onChange={e => setCode(e.target.value)}
//                                 /></div>
//                                 <div className="form-group mt-3">
//                                  <label>Please Enter a New Password:</label>
//                                 <input
//                                     type="password"
//                                     className="form-control mt-1"
//                                     placeholder="Enter New Password"
//                                     onChange={e => setPassword(e.target.value)}
//                                 />
//                                 </div>
//                                 <div className="form-group mt-3">
//                                  <label>Please Confirm the New Password:</label>
//                                 <input
//                                     type="password"
//                                     className="form-control mt-1"
//                                     placeholder="Confirm New Password"
//                                     onChange={e => setConfirmPassword(e.target.value)}
//                                 />
//                                 </div>
//                         <div className="form-group mt-3">
//                                  <label> *Password must be at least 12 characters in length, and must contain an UPPERCASE, lowercase, Number, and a Special Character.</label>
//                                  </div>
//                         <div className="d-grid gap-2 mt-3">
//                             <button type="submit" className="btn btn-primary" onClick={() => handleSubmit}>
//                             Submit
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         );
//     }
//     else {
//         return <Navigate replace to="/login" />;
//     }
// };
function App() {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(true);
     const { state } = useLocation();
     //let {state} =useLocation(); let {loggedIn, userName, authenticated} =state;
    const navbarItemClick = e => {
       
        console.log(e);
        if (e.detail.id === 'signout') {
            Auth.signOut().then(() => {
                window.location.reload();
                loggedIn = false;
                userName = "";
            });
        }
    }
    window.onload = function() {
        console.log("start")
        inactivityTime();
    }
    return <Navigate replace to="/login" />; 
}

export {App, AppLayoutUI};
